import { ScheduleI } from '~src/interfaces/schedule.interface';
import {
  GET_SCHEDULES_FAILED,
  GET_SCHEDULES_REQUEST,
  GET_SCHEDULES_SUCCESS,
  RESET_SCHEDULES,
} from '~src/modules/surveys/constants/actionTypes';
import { defaultPulseCheckApi } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';

/*
export interface Segment {
  name?: string;  <--what about this. is this from Elasticsearch?
}
 */


export function fetchSchedulesOfSurvey(id: string): AsyncAction<ScheduleI[]> {
  return {
    types: [GET_SCHEDULES_REQUEST, GET_SCHEDULES_SUCCESS, GET_SCHEDULES_FAILED],
    callAPI: () => defaultPulseCheckApi.getSurveySchedules(id),
  };
}

export function resetSchedules() {
  return { type: RESET_SCHEDULES };
}
